import AICreditManager from '@/components/billing/AICreditManager';
import useOsDark from '../../hooks/useOsDark';

export default function AICredits() {
  const isDark = useOsDark();

  return <AICreditManager embedded desktopTheme={isDark ? 'dark' : 'light'} />;
}